var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 21V13.6C9.5 13.0399 9.5 12.7599 9.60899 12.546C9.70487 12.3578 9.85785 12.2049 10.046 12.109C10.2599 12 10.5399 12 11.1 12H13.9C14.4601 12 14.7401 12 14.954 12.109C15.1422 12.2049 15.2951 12.3578 15.391 12.546C15.5 12.7599 15.5 13.0399 15.5 13.6V21M11.5177 2.764L4.73539 8.03912C4.28202 8.39175 4.05534 8.56806 3.89203 8.78886C3.74737 8.98444 3.6396 9.20478 3.57403 9.43905C3.5 9.70352 3.5 9.9907 3.5 10.5651V17.8C3.5 18.9201 3.5 19.4801 3.71799 19.908C3.90973 20.2843 4.21569 20.5903 4.59202 20.782C5.01984 21 5.57989 21 6.7 21H18.3C19.4201 21 19.9802 21 20.408 20.782C20.7843 20.5903 21.0903 20.2843 21.282 19.908C21.5 19.4801 21.5 18.9201 21.5 17.8V10.5651C21.5 9.9907 21.5 9.70352 21.426 9.43905C21.3604 9.20478 21.2526 8.98444 21.108 8.78886C20.9447 8.56806 20.718 8.39175 20.2646 8.03913L13.4823 2.764C13.131 2.49075 12.9553 2.35412 12.7613 2.3016C12.5902 2.25526 12.4098 2.25526 12.2387 2.3016C12.0447 2.35412 11.869 2.49075 11.5177 2.764Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.7f453edccf2bbc526fedfb89aa8b2e59.svg";
export { ForwardRef as ReactComponent };